module.exports = __webpack_public_path__ + "img/dam_breaking_thumb.84e42831.jpg";